import { StreamPricingType } from '@/__generated__/graphql.ts';
import { makeSelectOptions } from '@/routes/_app.p.marketplace.streams/stream-filters/make-select-options.ts';
import { StreamFilterItem } from '@/routes/_app.p.marketplace.streams/stream-filters/stream-filters.tsx';

const PricingOptions = {
  [StreamPricingType.All]: 'Paid + Free',
  [StreamPricingType.Free]: 'Free',
  [StreamPricingType.Paid]: 'Paid',
  [StreamPricingType.PackageOnly]: 'In Package',
};

const pricingSelectOptions = makeSelectOptions(PricingOptions);

export const PricingTypeFilter = () => {
  return (
    <StreamFilterItem
      paramName={'pricingType'}
      defaultValue={StreamPricingType.All}
      optionsEntity={PricingOptions}
      options={pricingSelectOptions}
    />
  );
};
